/**
 * Renders chat message text with conversational typography.
 * Labels like "Sale:" or "Quantity:" get semibold; body stays regular weight.
 */
export default function ChatMessageBody({ text }) {
  if (!text) return null;

  const lines = String(text).split("\n");

  return (
    <div className="chat-message-body">
      {lines.map((line, i) => {
        const trimmed = line.trim();
        if (!trimmed) {
          return <div key={i} className="chat-line-spacer" aria-hidden />;
        }

        const labeled = trimmed.match(/^([A-Za-z][A-Za-z\s]{0,24}):\s*(.+)$/);
        if (labeled) {
          return (
            <div key={i} className="chat-line">
              <span className="chat-label">{labeled[1]}:</span>{" "}
              <span className="chat-value">{labeled[2]}</span>
            </div>
          );
        }

        const bullet = trimmed.match(/^[•\-]\s*(.+)$/);
        if (bullet) {
          return (
            <div key={i} className="chat-line chat-bullet">
              {bullet[1]}
            </div>
          );
        }

        return (
          <div key={i} className="chat-line">
            {trimmed}
          </div>
        );
      })}
    </div>
  );
}
